import styled from 'styled-components';

/* Mixins */
import {
  WebFontHeader3,
  WebFontCalloutSemibold2,
  FlexDirectionColumn,
  FlexRow,
  BoxSizingSelfAndChildren,
} from 'styles/Mixins';

/* Utils */
import { mediaQuery } from 'styles/Utils';

/* Constants */
import { HORIZONTAL_PADDING } from 'styles/landing/LandingPage';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.darkCobalt};
  ${WebFontCalloutSemibold2};
  ${BoxSizingSelfAndChildren};
  ${FlexDirectionColumn};
  ${mediaQuery.mobile`
    padding: 48px ${HORIZONTAL_PADDING};
  `}
  ${mediaQuery.desktop`
    padding: 88px ${HORIZONTAL_PADDING};
  `}
`;

export const Container = styled.div`
  ${mediaQuery.mobile`
    ${FlexDirectionColumn};
  `}
  ${mediaQuery.desktop`
    ${FlexRow};
  `}
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const Heading = styled.div`
  ${WebFontHeader3};
  color: ${({ theme }) => theme.white};
  margin-bottom: 20px;
`;

export const HeadingContainer = styled.div`
  ${FlexDirectionColumn};
  align-items: stretch;

  ${mediaQuery.desktop`
    max-width: 320px;
    margin-right: 40px;
  `}
`;

export const ColumnContainer = styled.div<{ margin?: string }>`
  ${FlexDirectionColumn};
  align-items: flex-start;
  ${({ margin }) => margin && `margin: ${margin};`}
`;

export const RowContainer = styled.div<{ margin?: string }>`
  ${FlexRow};
  justify-content: space-between;
  ${({ margin }) => margin && `margin: ${margin};`}
`;

export const LinksContainer = styled.div`
  display: flex;
  ${mediaQuery.mobile`
    flex-direction: column;
    width: 100%;
  `}
  ${mediaQuery.desktop`
    flex-direction: row-reverse;
  `}
`;

export const Link = styled.a<{ noHover?: boolean }>`
  margin-bottom: 8px;
  white-space: pre;
  color: ${({ theme }) => theme.white};
  font-weight: 600;
  &:hover {
    ${({ noHover }) => !noHover && 'text-decoration: underline !important;'};
  }
  ${({ noHover }) => noHover && 'cursor: default;'};
`;
